<template>
  <v-dialog
    :value="true"
    persistent
    max-width="80%"
  >
    <v-card>
      <v-card-title>{{ title }}</v-card-title>
      <v-card-text>
        <div>
          <v-data-table
            :items-per-page="10"
            dense
            :items="items"
            :headers="headers"
            :footer-props="datatableFooter"
            no-data-text="Нет данных для отображения"
          />
        </div>
      </v-card-text>
      <v-card-actions>
        <div
          class="mx-5"
          style="width: 100%"
        >
          <v-row class="justify-center">
            <v-col
              cols="12"
            >
              <v-btn
                color="primary"
                outlined
                large
                min-width="100"
                @click="onCloseNomenclatureDialog()"
              >
                <span class="mx-3">Закрыть</span>
              </v-btn>
            </v-col>
            <!--            <v-col-->
            <!--              cols="6"-->
            <!--              class="d-flex justify-end"-->
            <!--            >-->
            <!--              <v-btn-->
            <!--                color="primary"-->
            <!--                large-->
            <!--                min-width="200"-->
            <!--                @click="onAddNomenclature()"-->
            <!--              >-->
            <!--                Добавить-->
            <!--              </v-btn>-->
            <!--            </v-col>-->
          </v-row>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: 'DialogImport',
  props: ['items', 'headers', 'title'],
  data: () => ({
    datatableFooter: {
      itemsPerPageText: 'Показывать по',
      pageText: 'из',
      itemsPerPageAllText: 'Все',
    },
    // selectedItems: []
  }),
  methods: {
    // onAddNomenclature () {
    //   this.$emit('change', this.selectedItems)
    // },
    onCloseNomenclatureDialog () {
      this.$emit('close')
    },
  }
}
</script>

<style scoped>

</style>
